import React from 'react'
import styled from 'styled-components'

export const ToggleGroup = styled.div`
  display: flex;
  background: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  margin: 0 ${({ theme }) => theme.spacing.medium};
  padding: 4px;
  gap: 4px;
`

export const ToggleOption = styled.button<{ $active?: boolean }>`
  flex: 1;
  padding: ${({ theme }) => `${theme.spacing.small} ${theme.spacing.medium}`};
  border: none;
  background: ${({ $active, theme }) =>
    $active ? theme.colors.background.primary : 'transparent'};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  font-size: 10px;
  font-weight: 500;
  color: ${({ $active, theme }) =>
    $active ? theme.colors.primary : theme.colors.text.secondary};
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.default};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.xsmall};
  font-family: inherit;
  box-shadow: ${({ $active, theme }) => ($active ? theme.shadows.sm : 'none')};

  &:hover {
    color: ${({ $active, theme }) =>
      $active ? theme.colors.primary : theme.colors.text.primary};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`

// For convenience, export a compound component
interface ToggleGroupComponentProps {
  options: Array<{
    value: string
    label: string
    icon?: React.ReactNode
  }>
  value: string
  onChange: (value: string) => void
  className?: string
}

export const ToggleGroupComponent: React.FC<ToggleGroupComponentProps> = ({
  options,
  value,
  onChange,
  className,
}) => {
  return (
    <ToggleGroup className={className}>
      {options.map((option) => (
        <ToggleOption
          key={option.value}
          $active={value === option.value}
          onClick={() => onChange(option.value)}
        >
          {option.icon}
          {option.label}
        </ToggleOption>
      ))}
    </ToggleGroup>
  )
}
